import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Factory} from './components/factory';

class ExposureBoxComponent extends Component {
    render() {
        const {sportConfig, isMobile = false} = this.props;

        if (isMobile) {
            return Factory.getMobileComponent(sportConfig);
        }

        return Factory.getDesktopComponent(sportConfig);
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const ExposureBox = connect(mapStatesToProps)(ExposureBoxComponent);

export {ExposureBox};
